import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase-config';

const SaybicDashboard = () => {

  const handleLogout = () => {
    signOut(auth)
      .then(() => window.location.reload())
      .catch((error) => console.error('Error al cerrar sesión:', error));
  };

  return (
    <div
      style={{
        padding: '1rem 1rem 2rem 1rem',
        backgroundColor: '#243b5a',
        minHeight: '100vh'
      }}
    >

      {/* contenedor centrado */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          padding: '10px 10px 0px 10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
      >

        {/* barra superior */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '6px'
          }}
        >
          <button
            onClick={handleLogout}
            style={{
              padding: '4px 10px',
              fontSize: '12px',
              backgroundColor: '#243b5a',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cerrar sesión
          </button>
        </div>


        {/* contenedor responsive 16:9 */}
        <div
          style={{
            width: '100%',
            maxWidth: '1280px',
            margin: '0 auto',
            aspectRatio: '16 / 9',
            background: '#fff',
            borderRadius: '8px',
            overflow: 'hidden'
          }}
        >
          <iframe
            title="dashboard"
            src="https://app.powerbi.com/view?r=eyJrIjoiZWE4MTI0OGMtMDM1Ni00MDg4LTk1NDktNDAzZGYzZTlkMTllIiwidCI6ImQyODAxN2UzLWRlYTMtNDhlNC1hYzdmLTAwYWYyY2QxNjQ0YiJ9"
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allowFullScreen
          />
        </div>

      </div>
    </div>
  );
};

export default SaybicDashboard;